import script from "./Tab.vue?vue&type=script&lang=ts&setup=true"
export * from "./Tab.vue?vue&type=script&lang=ts&setup=true"

import "./Tab.vue?vue&type=style&index=0&id=4ed646cb&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1212641435/src/bitbucket.org/labtravelfactory/booking-funnel-xftless/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ed646cb"]])

export default __exports__